/**
 * Gemeinsame Begriffe der Webinar-/Bestellseiten-Oberflaeche (Plan 2026-10-22). Eine Quelle, damit dieselbe
 * Sache ueberall gleich heisst — Personas lasen „publizieren / umschalten / live schalten“ als drei Schritte,
 * „published“ und „LIVE“ als zwei Zustaende.
 *
 * Regel: Begriffe hier aendern, nicht an der Fundstelle. Technikbegriffe (order_url, Hash, Journal, SES, Mux)
 * gehoeren nur in Bereiche, die `NurAdmin` umschliesst.
 */

export const BEGRIFF = {
  kuerzel: 'Kürzel (Tracking)',
  oeffentlicherTitel: 'Öffentlicher Titel',
  internerTitel: 'Interner Titel',
  produkt: 'Produkt (PL-X)',
  mail: 'Mail',
  versandAktivieren: 'Versand aktivieren',
  entwurf: 'Entwurf',
  aktiv: 'aktiv',
  veroeffentlichen: 'Veröffentlichen',
  veroeffentlicht: 'Veröffentlicht',
  live: 'Live',
  bestellstrecke: 'Bestellstrecke',
  raumSperren: 'Raum sperren (Notfall)',
  testLink: 'Test-Link',
  varianteAB: 'Variante A/B (Test)',
} as const;

export const KENNZEICHEN_TEXT = {
  pflicht: 'Pflicht',
  pflichtVerkauf: 'Pflicht für den Verkauf',
  empfohlen: 'Empfohlen',
  optional: 'Optional',
  automatisch: 'Läuft automatisch',
  admin: 'Nur Admin',
} as const;

export const KENNZEICHEN_ERKLAERUNG = {
  pflicht: 'Ohne dieses Feld wird das Webinar nicht beworben.',
  pflichtVerkauf: 'Ohne dieses Feld gibt es im Webinar kein Kaufangebot.',
  empfohlen: 'Kann leer bleiben, ist für ein gutes Ergebnis aber wichtig — der Satz am Feld sagt, warum.',
  optional: 'Kann leer bleiben — dann gilt der beschriebene Standard.',
  automatisch: 'Das System erledigt das selbst. Hier ist nichts zu tun.',
  admin: 'Technische Einstellung. Für Marketing nicht nötig.',
} as const;

/** Datum Berlin `YYYY-MM-DD[ HH:mm…]` → `25.10.2026` (ein Format für die ganze Oberfläche). */
export function datumDe(iso: string | null | undefined): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso ?? ''));
  return m ? `${m[3]}.${m[2]}.${m[1]}` : '';
}
